export const PortfolioPublicFlg = {
  PROVISIONAL: 0,
  DRAFT: 1,
  PUBLIC: 2,
} as const

export const PortfolioDisplayStatus = {
  APPROVAL: 1,
  PUBLIC: 2,
  ALL_COMPANIES: 3,
  PRIVATE: 4,
} as const

export type PortfolioDisplayStatus =
  (typeof PortfolioDisplayStatus)[keyof typeof PortfolioDisplayStatus]

export type PortfolioContentsVersion = 1

export type PortfolioContentType =
  | 'text'
  | 'image'
  | 'pdf'
  | 'video'
  | 'figma'
  | 'link'
  | 'file'

export type PortfolioContentBase = {
  type: PortfolioContentType
  id: string
}

export type PortfolioContentText = PortfolioContentBase & {
  type: 'text'
  text: string
}

export type PortfolioContentFile = PortfolioContentBase & {
  type: 'file'
}

export type PortfolioContentImage = PortfolioContentBase & {
  type: 'image'
  path: string
  width: number
  height: number
}

export type PortfolioContentPdf = PortfolioContentBase & {
  type: 'pdf'
  path: string
}

export type PortfolioContentEmbed = PortfolioContentBase & {
  type: 'video' | 'figma'
  url: string
}

export type PortfolioContentLink = PortfolioContentBase & {
  type: 'link'
  url: string
  title: string
  description: string
  thumbnail: string
}

export type PortfolioContentItem =
  | PortfolioContentText
  | PortfolioContentPdf
  | PortfolioContentImage
  | PortfolioContentEmbed
  | PortfolioContentLink
  | PortfolioContentFile

export type PortfolioContents = {
  version: PortfolioContentsVersion
  items: PortfolioContentItem[]
}
